import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";

import IndustriesHero from "./IndustriesHero";
import JumpToNav from "./JumpToNav";
import IndustryDetailSection from "./IndustryDetailSection";

const IndustriesWeServe = () => {
  const location = useLocation();
  const [activeId, setActiveId] = useState("health-care");

  useEffect(() => {
    AOS.init({ duration: 800, once: true });
    window.scrollTo(0, 0);
    document.title = "Industries We Serve | NKENNE AI";
  }, []);

  // Sync with URL hash if present (e.g., #fintech, #health-care)
  useEffect(() => {
    if (location.hash) {
      const targetId = location.hash.replace("#", "");
      if (targetId) {
        setActiveId(targetId);
        const el = document.getElementById(targetId);
        if (el) {
          el.scrollIntoView({ behavior: "smooth" });
        }
      }
    }
  }, [location.hash]);

  const handleSelect = (id) => {
    setActiveId(id);
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <div className="flex flex-col w-full relative bg-white">
      {/* 1. Hero with sub-use-case-hero.png */}
      <IndustriesHero />

      {/* 2. Jump To Navigation Bar */}
      <JumpToNav activeId={activeId} onSelect={handleSelect} />

      {/* 3. Industry Details with health-care-img.png */}
      <IndustryDetailSection activeId={activeId} />
    </div>
  );
};

export default IndustriesWeServe;
